import React, { useEffect } from "react";
import { getConfigValue } from "@jutro/config";
import { warning } from "@jutro/logger";
import { GenericAuthProvider } from "./generic/GenericAuthProvider";
import { OktaAuthProvider } from "./okta/OktaAuthProvider";
var checkAndWarnEnvVariable = function (varName) {
  void 0 !== getConfigValue(varName) && warning("".concat(varName, " env variable is deprecated. Please refer to migration guide for new Auth API"));
};
export var AuthProvider = function (props) {
  var isGenericClient = getConfigValue("JUTRO_AUTH_GENERIC_CLIENT", !1);
  return useEffect(function () {
    isGenericClient || warning("JUTRO_AUTH_GENERIC_CLIENT is set to false. Old, Okta-based auth API will be used. You can switch to new, generic auth API by setting JUTRO_AUTH_GENERIC_CLIENT to true");
  }, [isGenericClient]), useEffect(function () {
    checkAndWarnEnvVariable("JUTRO_AUTH_PKCE_ENABLED"), checkAndWarnEnvVariable("JUTRO_AUTH_IDP"), checkAndWarnEnvVariable("JUTRO_AUTH_AUTO_RENEW");
  }, []), isGenericClient ? React.createElement(GenericAuthProvider, props) : React.createElement(OktaAuthProvider, props);
};
AuthProvider.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AuthProvider"
}, AuthProvider.__docgenInfo = {
  componentName: "AuthProvider",
  packageName: "@jutro/auth",
  description: "",
  displayName: "AuthProvider",
  methods: [],
  actualName: "AuthProvider"
};